import { render, staticRenderFns } from "./Step_1.vue?vue&type=template&id=5bd71f2a&scoped=true&"
import script from "./Step_1.vue?vue&type=script&lang=ts&"
export * from "./Step_1.vue?vue&type=script&lang=ts&"
import style0 from "./Step_1.vue?vue&type=style&index=0&id=5bd71f2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd71f2a",
  null
  
)

export default component.exports